export default __webpack_public_path__ + "static/media/services-icon2.a2efff70.png";